(function () {
	'use strict';
	angular.module('app.setup')
        .controller('dataPipelineHealthCheckHistory', dataPipelineHealthCheckHistory);
        
	dataPipelineHealthCheckHistory.$inject = ['$rootScope', '$scope', '$location', '$timeout', '$experiments', 'columnsService', 'leanFilterService', '$translate'];

	function dataPipelineHealthCheckHistory($rootScope, $scope, $location, $timeout, $experiments, columnsService, leanFilterService, $translate) {
    
		var vm = this;
		vm.useReactReport = false;

		$scope.reportSettingsName = 'data-pipeline-health-check-history';
		$scope.factoryNdx = $location.search().factoryNdx;
		$scope.healthCheckName = $location.search().healthCheckName;
		$scope.summaryHref = '/application/f/home.html#/setup/data-pipeline';
		$scope.factoryHref = '/application/f/home.html#/setup/data-pipeline-history?&factoryNdx=' + $scope.factoryNdx;
		$scope.factoryAlias = globalConfig.user.authFacts[$scope.factoryNdx].alias;
		$scope.pageTitle = $translate.instant('Health check history:') + ' ' +  $scope.factoryAlias;

		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#supplyChainDataPipeline').addClass('selected');
		}, 0);

		init();

		function init() {
			leanFilterService.clearFilters();
		}
	}
})();
